import { ACTIVE_ITEMS } from '@constants/activeItems';
import { RootContext } from 'components/RootContainer';
import { FC, ReactNode, useCallback, useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import { ReservationStateEnumModel } from '../../../../../../../../../@constants/system/ReservationStateEnumModel';
import SelectMultiple from '../../../../../../../../../components/SelectMultiple';
import { DateTypeEnum } from '../../../models';

export const StateField: FC<{
  value: Array<number> | null;
  onChange: (value: Array<number> | null) => void;
  error?: ReactNode;
  dateType: DateTypeEnum;
}> = ({ value, onChange, error, dateType }) => {
  const {
    HotelApi: { settings: SettingsService },
  } = useContext(RootContext);

  const { isLoading, data } = useQuery({
    queryKey: ['states'],
    queryFn: () =>
      SettingsService.reservation.reservationState.getAll({
        search: [ACTIVE_ITEMS],
      }),
    enabled: true,
  });

  const getCancelledStateId = useCallback(() => {
    return data?.find(item => item.system_value === ReservationStateEnumModel.CANCELLED)?.id;
  }, [data]);

  useEffect(() => {
    if (dateType === DateTypeEnum.CANCELLATION_DATE) {
      onChange([getCancelledStateId() ?? -1]);
    }
  }, [dateType]);

  if (isLoading) {
    return <>...</>;
  }

  if (isLoading) {
    return <>...</>;
  }

  return (
    <SelectMultiple
      variant="standard"
      inputLabel="State"
      options={
        dateType === DateTypeEnum.CANCELLATION_DATE
          ? data?.filter(item => item.id === getCancelledStateId()) ?? []
          : data ?? []
      }
      getOptionLabel={item => item.name}
      getOptionValue={item => String(item.id!)}
      onChange={val => onChange((val || [])?.map(Number))}
      value={value ? (value || []).map(String) : ['']}
    />
  );
};
